import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import amapConfig from './config/amapConfig'; // 1. 引入配置

// 2. ★★★ 必须放在最前面配置安全密钥 ★★★
window._AMapSecurityConfig = {
  securityJsCode: amapConfig.securityJsCode,
};

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  render: h => h(App),
}).$mount('#app')